module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAYAAAB24g05AAAACXBIWXMAAAsSAAALEgHS3X78AAABAUlEQVQokXWSwU3DQBBFnxFHDpTAiYMvJBWQSL4zqYCUABVACSmBVOApwBKhAszFV6CDIHFEWvTFLHLM8i+z4/nz98+sq5QSJbj7GTADFHsz25V4fwTc/RR4AK4m3HdgPRU6EIhmES6Ktn4wN7M+J8eT4s2o+TbiJ/AFWIjviw7cfRbWs8ASeMxnWa+6QZyFhFJT978C7u6FmZdB3pvZpuoGiV+P6tvU1Ouqbdt74K4wa3awWp2cvwHPwEuM4uF0fhS3/IcnQM2ZY6mplUtEWEjgYCkjbOKs/yA/nVfdoFwOhJ0EMnEKWbxUPRa2jW+vEbWDPi9RlrSL0vt/yHLxFYBvwepkyLDheXgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/bimstream_pending.png
// module id = pUtk
// module chunks = 1